/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Student_Feature_4Inputs */

const en_settings_student_feature_4 = /** @type {(inputs: Settings_Student_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF + DOCX export`)
};

const de_settings_student_feature_4 = /** @type {(inputs: Settings_Student_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF + DOCX-Export`)
};

const fr_settings_student_feature_4 = /** @type {(inputs: Settings_Student_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export PDF + DOCX`)
};

const es_settings_student_feature_4 = /** @type {(inputs: Settings_Student_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación PDF + DOCX`)
};

const it_settings_student_feature_4 = /** @type {(inputs: Settings_Student_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione PDF + DOCX`)
};

const nl_settings_student_feature_4 = /** @type {(inputs: Settings_Student_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF + DOCX export`)
};

const pl_settings_student_feature_4 = /** @type {(inputs: Settings_Student_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksport PDF + DOCX`)
};

const fi_settings_student_feature_4 = /** @type {(inputs: Settings_Student_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF + DOCX vienti`)
};

const da_settings_student_feature_4 = /** @type {(inputs: Settings_Student_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF + DOCX-eksport`)
};

const sv_settings_student_feature_4 = /** @type {(inputs: Settings_Student_Feature_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF + DOCX export`)
};

/**
* | output |
* | --- |
* | "PDF + DOCX export" |
*
* @param {Settings_Student_Feature_4Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_student_feature_4 = /** @type {((inputs?: Settings_Student_Feature_4Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Student_Feature_4Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_student_feature_4(inputs)
	if (locale === "fr") return fr_settings_student_feature_4(inputs)
	if (locale === "es") return es_settings_student_feature_4(inputs)
	if (locale === "it") return it_settings_student_feature_4(inputs)
	if (locale === "nl") return nl_settings_student_feature_4(inputs)
	if (locale === "pl") return pl_settings_student_feature_4(inputs)
	if (locale === "fi") return fi_settings_student_feature_4(inputs)
	if (locale === "da") return da_settings_student_feature_4(inputs)
	if (locale === "sv") return sv_settings_student_feature_4(inputs)
	return en_settings_student_feature_4(inputs)
});